import { RaisedButton } from 'material-ui';
import * as React from 'react';

export class Topics extends React.Component {
  public render() {
    return (
      <div>
        <RaisedButton label="Default" /> xxx
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/topics.tsx